import PropTypes from 'prop-types';
import React, { createContext } from 'react';
export const StyleContext = createContext();
export const StyleProvider = ({ initialStyle, children }) => (React.createElement(StyleContext.Provider, { value: initialStyle }, children));
StyleProvider.propTypes = {
    initialStyle: PropTypes.object.isRequired,
    children: PropTypes.any
};
